// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  Count,
  CountFromJSON,
  CountToJSON,
  Risk,
  RiskFromJSON,
  RiskToJSON,
  RiskAssociation,
  RiskAssociationFromJSON,
  RiskAssociationToJSON,
  RiskCoverageReport,
  RiskCoverageReportFromJSON,
  RiskCoverageReportToJSON,
  RiskLinkPayload,
  RiskLinkPayloadFromJSON,
  RiskLinkPayloadToJSON,
  RiskPayload,
  RiskPayloadFromJSON,
  RiskPayloadToJSON,
  RiskScaleValue,
  RiskScaleValueFromJSON,
  RiskScaleValueToJSON,
  RiskScaleValuePayload,
  RiskScaleValuePayloadFromJSON,
  RiskScaleValuePayloadToJSON,
  RiskSettings,
  RiskSettingsFromJSON,
  RiskSettingsToJSON,
  RiskSettingsPayload,
  RiskSettingsPayloadFromJSON,
  RiskSettingsPayloadToJSON,
  RiskStatus,
  RiskStatusFromJSON,
  RiskStatusToJSON,
  RiskStatusPayload,
  RiskStatusPayloadFromJSON,
  RiskStatusPayloadToJSON,
  RiskType,
  RiskTypeFromJSON,
  RiskTypeToJSON,
  RiskTypePayload,
  RiskTypePayloadFromJSON,
  RiskTypePayloadToJSON,
  TCError,
  TCErrorFromJSON,
  TCErrorToJSON,
} from "../models";

export interface CreateRiskRequest {
  riskPayload?: RiskPayload;
}

export interface CreateRiskScaleValueRequest {
  riskScaleValuePayload?: RiskScaleValuePayload;
}

export interface CreateRiskStatusRequest {
  riskStatusPayload?: RiskStatusPayload;
}

export interface CreateRiskTypeRequest {
  riskTypePayload?: RiskTypePayload;
}

export interface DeleteRiskRequest {
  id: number;
  project: number;
}

export interface DeleteRiskScaleValueRequest {
  id: number;
  project: number;
}

export interface DeleteRiskStatusRequest {
  id: number;
  project: number;
}

export interface DeleteRiskTypeRequest {
  id: number;
  project: number;
}

export interface GetRiskRequest {
  id: number;
  project: number;
}

export interface GetRiskAssociationsRequest {
  id: number;
  project: number;
}

export interface GetRiskCountRequest {
  project: number;
  filter?: string;
}

export interface GetRiskCoverageRequest {
  project: number;
  testplan?: number;
}

export interface GetRiskScaleValuesRequest {
  project: number;
  axis?: GetRiskScaleValuesAxisEnum;
}

export interface GetRiskSettingsRequest {
  project: number;
}

export interface GetRiskStatusesRequest {
  project: number;
}

export interface GetRiskTypesRequest {
  project: number;
}

export interface GetRisksRequest {
  project: number;
  status?: number;
  exposureBand?: GetRisksExposureBandEnum;
  riskType?: number;
  owner?: number;
  limit?: number;
  start?: number;
  sort?: string;
  filter?: string;
}

export interface LinkRiskAssociationRequest {
  id: number;
  project: number;
  riskLinkPayload?: RiskLinkPayload;
}

export interface UnlinkRiskAssociationRequest {
  id: number;
  project: number;
  riskLinkPayload?: RiskLinkPayload;
}

export interface UpdateRiskRequest {
  id: number;
  riskPayload?: RiskPayload;
}

export interface UpdateRiskScaleValueRequest {
  id: number;
  riskScaleValuePayload?: RiskScaleValuePayload;
}

export interface UpdateRiskSettingsRequest {
  project: number;
  riskSettingsPayload?: RiskSettingsPayload;
}

export interface UpdateRiskStatusRequest {
  id: number;
  riskStatusPayload?: RiskStatusPayload;
}

export interface UpdateRiskTypeRequest {
  id: number;
  riskTypePayload?: RiskTypePayload;
}

/**
 * no description
 */
export class RisksApi extends runtime.BaseAPI {
  /**
   * Create a new risk. Exposure and exposure_band are computed server-side from likelihood and impact.
   * Create a risk
   */
  async createRiskRaw(
    requestParameters: CreateRiskRequest
  ): Promise<runtime.ApiResponse<Risk>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/risks`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: RiskPayloadToJSON(requestParameters.riskPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RiskFromJSON(jsonValue)
    );
  }

  /**
   * Create a new risk. Exposure and exposure_band are computed server-side from likelihood and impact.
   * Create a risk
   */
  async createRisk(requestParameters: CreateRiskRequest): Promise<Risk> {
    const response = await this.createRiskRaw(requestParameters);
    return await response.value();
  }

  /**
   * Add a likelihood/impact scale value (admin-only risk config)
   * Create a risk scale value
   */
  async createRiskScaleValueRaw(
    requestParameters: CreateRiskScaleValueRequest
  ): Promise<runtime.ApiResponse<RiskScaleValue>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/riskscalevalues`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: RiskScaleValuePayloadToJSON(
        requestParameters.riskScaleValuePayload
      ),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RiskScaleValueFromJSON(jsonValue)
    );
  }

  /**
   * Add a likelihood/impact scale value (admin-only risk config)
   * Create a risk scale value
   */
  async createRiskScaleValue(
    requestParameters: CreateRiskScaleValueRequest
  ): Promise<RiskScaleValue> {
    const response = await this.createRiskScaleValueRaw(requestParameters);
    return await response.value();
  }

  /**
   * Add a custom risk status (admin-only risk config)
   * Create a risk status
   */
  async createRiskStatusRaw(
    requestParameters: CreateRiskStatusRequest
  ): Promise<runtime.ApiResponse<RiskStatus>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/riskstatuses`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: RiskStatusPayloadToJSON(requestParameters.riskStatusPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RiskStatusFromJSON(jsonValue)
    );
  }

  /**
   * Add a custom risk status (admin-only risk config)
   * Create a risk status
   */
  async createRiskStatus(
    requestParameters: CreateRiskStatusRequest
  ): Promise<RiskStatus> {
    const response = await this.createRiskStatusRaw(requestParameters);
    return await response.value();
  }

  /**
   * Add a custom risk type (admin-only risk config)
   * Create a risk type
   */
  async createRiskTypeRaw(
    requestParameters: CreateRiskTypeRequest
  ): Promise<runtime.ApiResponse<RiskType>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/risktypes`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: RiskTypePayloadToJSON(requestParameters.riskTypePayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RiskTypeFromJSON(jsonValue)
    );
  }

  /**
   * Add a custom risk type (admin-only risk config)
   * Create a risk type
   */
  async createRiskType(
    requestParameters: CreateRiskTypeRequest
  ): Promise<RiskType> {
    const response = await this.createRiskTypeRaw(requestParameters);
    return await response.value();
  }

  /**
   * Delete a specific risk
   * Delete a risk
   */
  async deleteRiskRaw(
    requestParameters: DeleteRiskRequest
  ): Promise<runtime.ApiResponse<any>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling deleteRisk."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling deleteRisk."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/risks/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.TextApiResponse(response);
  }

  /**
   * Delete a specific risk
   * Delete a risk
   */
  async deleteRisk(requestParameters: DeleteRiskRequest): Promise<any> {
    const response = await this.deleteRiskRaw(requestParameters);
    return await response.value();
  }

  /**
   * Delete a likelihood/impact scale value (admin-only risk config)
   * Delete a risk scale value
   */
  async deleteRiskScaleValueRaw(
    requestParameters: DeleteRiskScaleValueRequest
  ): Promise<runtime.ApiResponse<any>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling deleteRiskScaleValue."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling deleteRiskScaleValue."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/riskscalevalues/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.TextApiResponse(response);
  }

  /**
   * Delete a likelihood/impact scale value (admin-only risk config)
   * Delete a risk scale value
   */
  async deleteRiskScaleValue(
    requestParameters: DeleteRiskScaleValueRequest
  ): Promise<any> {
    const response = await this.deleteRiskScaleValueRaw(requestParameters);
    return await response.value();
  }

  /**
   * Delete a custom risk status (system statuses cannot be deleted)
   * Delete a risk status
   */
  async deleteRiskStatusRaw(
    requestParameters: DeleteRiskStatusRequest
  ): Promise<runtime.ApiResponse<any>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling deleteRiskStatus."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling deleteRiskStatus."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/riskstatuses/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.TextApiResponse(response);
  }

  /**
   * Delete a custom risk status (system statuses cannot be deleted)
   * Delete a risk status
   */
  async deleteRiskStatus(
    requestParameters: DeleteRiskStatusRequest
  ): Promise<any> {
    const response = await this.deleteRiskStatusRaw(requestParameters);
    return await response.value();
  }

  /**
   * Delete a custom risk type (admin-only risk config)
   * Delete a risk type
   */
  async deleteRiskTypeRaw(
    requestParameters: DeleteRiskTypeRequest
  ): Promise<runtime.ApiResponse<any>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling deleteRiskType."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling deleteRiskType."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/risktypes/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.TextApiResponse(response);
  }

  /**
   * Delete a custom risk type (admin-only risk config)
   * Delete a risk type
   */
  async deleteRiskType(requestParameters: DeleteRiskTypeRequest): Promise<any> {
    const response = await this.deleteRiskTypeRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get details of a single risk, including scoring and associations
   * Get risk
   */
  async getRiskRaw(
    requestParameters: GetRiskRequest
  ): Promise<runtime.ApiResponse<Risk>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getRisk."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getRisk."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/risks/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RiskFromJSON(jsonValue)
    );
  }

  /**
   * Get details of a single risk, including scoring and associations
   * Get risk
   */
  async getRisk(requestParameters: GetRiskRequest): Promise<Risk> {
    const response = await this.getRiskRaw(requestParameters);
    return await response.value();
  }

  /**
   * List the entities linked to a risk (requirements, test cases, defects), forming the risk to test to result traceability chain.
   * List a risk's associations
   */
  async getRiskAssociationsRaw(
    requestParameters: GetRiskAssociationsRequest
  ): Promise<runtime.ApiResponse<Array<RiskAssociation>>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getRiskAssociations."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getRiskAssociations."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/risks/{id}/associations`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(RiskAssociationFromJSON)
    );
  }

  /**
   * List the entities linked to a risk (requirements, test cases, defects), forming the risk to test to result traceability chain.
   * List a risk's associations
   */
  async getRiskAssociations(
    requestParameters: GetRiskAssociationsRequest
  ): Promise<Array<RiskAssociation>> {
    const response = await this.getRiskAssociationsRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get risks' count
   * Get count of risks
   */
  async getRiskCountRaw(
    requestParameters: GetRiskCountRequest
  ): Promise<runtime.ApiResponse<Count>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getRiskCount."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.filter !== undefined) {
      queryParameters["_filter"] = requestParameters.filter;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/risks/count`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CountFromJSON(jsonValue)
    );
  }

  /**
   * Get risks' count
   * Get count of risks
   */
  async getRiskCount(requestParameters: GetRiskCountRequest): Promise<Count> {
    const response = await this.getRiskCountRaw(requestParameters);
    return await response.value();
  }

  /**
   * Risk-adjusted coverage for a project (or a test plan): coverage by risk level, residual risk, and risk burndown.
   * Get risk coverage report
   */
  async getRiskCoverageRaw(
    requestParameters: GetRiskCoverageRequest
  ): Promise<runtime.ApiResponse<RiskCoverageReport>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getRiskCoverage."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.testplan !== undefined) {
      queryParameters["testplan"] = requestParameters.testplan;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/risks/coverage`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RiskCoverageReportFromJSON(jsonValue)
    );
  }

  /**
   * Risk-adjusted coverage for a project (or a test plan): coverage by risk level, residual risk, and risk burndown.
   * Get risk coverage report
   */
  async getRiskCoverage(
    requestParameters: GetRiskCoverageRequest
  ): Promise<RiskCoverageReport> {
    const response = await this.getRiskCoverageRaw(requestParameters);
    return await response.value();
  }

  /**
   * List the configured likelihood/impact scale values for a project's risk template
   * List risk scale values
   */
  async getRiskScaleValuesRaw(
    requestParameters: GetRiskScaleValuesRequest
  ): Promise<runtime.ApiResponse<Array<RiskScaleValue>>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getRiskScaleValues."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.axis !== undefined) {
      queryParameters["axis"] = requestParameters.axis;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/riskscalevalues`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(RiskScaleValueFromJSON)
    );
  }

  /**
   * List the configured likelihood/impact scale values for a project's risk template
   * List risk scale values
   */
  async getRiskScaleValues(
    requestParameters: GetRiskScaleValuesRequest
  ): Promise<Array<RiskScaleValue>> {
    const response = await this.getRiskScaleValuesRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get the risk settings for a project, including the exposure_band thresholds
   * Get risk settings
   */
  async getRiskSettingsRaw(
    requestParameters: GetRiskSettingsRequest
  ): Promise<runtime.ApiResponse<RiskSettings>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getRiskSettings."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/risksettings`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RiskSettingsFromJSON(jsonValue)
    );
  }

  /**
   * Get the risk settings for a project, including the exposure_band thresholds
   * Get risk settings
   */
  async getRiskSettings(
    requestParameters: GetRiskSettingsRequest
  ): Promise<RiskSettings> {
    const response = await this.getRiskSettingsRaw(requestParameters);
    return await response.value();
  }

  /**
   * List the configured risk statuses (system and custom) for a project's risk template
   * List risk statuses
   */
  async getRiskStatusesRaw(
    requestParameters: GetRiskStatusesRequest
  ): Promise<runtime.ApiResponse<Array<RiskStatus>>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getRiskStatuses."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/riskstatuses`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(RiskStatusFromJSON)
    );
  }

  /**
   * List the configured risk statuses (system and custom) for a project's risk template
   * List risk statuses
   */
  async getRiskStatuses(
    requestParameters: GetRiskStatusesRequest
  ): Promise<Array<RiskStatus>> {
    const response = await this.getRiskStatusesRaw(requestParameters);
    return await response.value();
  }

  /**
   * List the configured risk types (e.g. Business, Technical, Compliance) for a project's risk template
   * List risk types
   */
  async getRiskTypesRaw(
    requestParameters: GetRiskTypesRequest
  ): Promise<runtime.ApiResponse<Array<RiskType>>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getRiskTypes."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/risktypes`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(RiskTypeFromJSON)
    );
  }

  /**
   * List the configured risk types (e.g. Business, Technical, Compliance) for a project's risk template
   * List risk types
   */
  async getRiskTypes(
    requestParameters: GetRiskTypesRequest
  ): Promise<Array<RiskType>> {
    const response = await this.getRiskTypesRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get list of risks for a project
   * Get list of risks
   */
  async getRisksRaw(
    requestParameters: GetRisksRequest
  ): Promise<runtime.ApiResponse<Array<Risk>>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getRisks."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.status !== undefined) {
      queryParameters["status"] = requestParameters.status;
    }

    if (requestParameters.exposureBand !== undefined) {
      queryParameters["exposure_band"] = requestParameters.exposureBand;
    }

    if (requestParameters.riskType !== undefined) {
      queryParameters["risk_type"] = requestParameters.riskType;
    }

    if (requestParameters.owner !== undefined) {
      queryParameters["owner"] = requestParameters.owner;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters["_limit"] = requestParameters.limit;
    }

    if (requestParameters.start !== undefined) {
      queryParameters["_start"] = requestParameters.start;
    }

    if (requestParameters.sort !== undefined) {
      queryParameters["_sort"] = requestParameters.sort;
    }

    if (requestParameters.filter !== undefined) {
      queryParameters["_filter"] = requestParameters.filter;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/risks`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(RiskFromJSON)
    );
  }

  /**
   * Get list of risks for a project
   * Get list of risks
   */
  async getRisks(requestParameters: GetRisksRequest): Promise<Array<Risk>> {
    const response = await this.getRisksRaw(requestParameters);
    return await response.value();
  }

  /**
   * Link a requirement, test case, or defect to a risk
   * Link an entity to a risk
   */
  async linkRiskAssociationRaw(
    requestParameters: LinkRiskAssociationRequest
  ): Promise<runtime.ApiResponse<RiskAssociation>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling linkRiskAssociation."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling linkRiskAssociation."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/risks/{id}/link`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: RiskLinkPayloadToJSON(requestParameters.riskLinkPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RiskAssociationFromJSON(jsonValue)
    );
  }

  /**
   * Link a requirement, test case, or defect to a risk
   * Link an entity to a risk
   */
  async linkRiskAssociation(
    requestParameters: LinkRiskAssociationRequest
  ): Promise<RiskAssociation> {
    const response = await this.linkRiskAssociationRaw(requestParameters);
    return await response.value();
  }

  /**
   * Remove a requirement, test case, or defect link from a risk
   * Unlink an entity from a risk
   */
  async unlinkRiskAssociationRaw(
    requestParameters: UnlinkRiskAssociationRequest
  ): Promise<runtime.ApiResponse<any>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling unlinkRiskAssociation."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling unlinkRiskAssociation."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/risks/{id}/unlink`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: RiskLinkPayloadToJSON(requestParameters.riskLinkPayload),
    });

    return new runtime.TextApiResponse(response);
  }

  /**
   * Remove a requirement, test case, or defect link from a risk
   * Unlink an entity from a risk
   */
  async unlinkRiskAssociation(
    requestParameters: UnlinkRiskAssociationRequest
  ): Promise<any> {
    const response = await this.unlinkRiskAssociationRaw(requestParameters);
    return await response.value();
  }

  /**
   * Update a risk. Exposure and exposure_band are recomputed when likelihood or impact change.
   * Update a risk
   */
  async updateRiskRaw(
    requestParameters: UpdateRiskRequest
  ): Promise<runtime.ApiResponse<Risk>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling updateRisk."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/risks/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: RiskPayloadToJSON(requestParameters.riskPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RiskFromJSON(jsonValue)
    );
  }

  /**
   * Update a risk. Exposure and exposure_band are recomputed when likelihood or impact change.
   * Update a risk
   */
  async updateRisk(requestParameters: UpdateRiskRequest): Promise<Risk> {
    const response = await this.updateRiskRaw(requestParameters);
    return await response.value();
  }

  /**
   * Update a likelihood/impact scale value (admin-only risk config)
   * Update a risk scale value
   */
  async updateRiskScaleValueRaw(
    requestParameters: UpdateRiskScaleValueRequest
  ): Promise<runtime.ApiResponse<RiskScaleValue>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling updateRiskScaleValue."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/riskscalevalues/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: RiskScaleValuePayloadToJSON(
        requestParameters.riskScaleValuePayload
      ),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RiskScaleValueFromJSON(jsonValue)
    );
  }

  /**
   * Update a likelihood/impact scale value (admin-only risk config)
   * Update a risk scale value
   */
  async updateRiskScaleValue(
    requestParameters: UpdateRiskScaleValueRequest
  ): Promise<RiskScaleValue> {
    const response = await this.updateRiskScaleValueRaw(requestParameters);
    return await response.value();
  }

  /**
   * Update the project's risk settings, including the exposure_band thresholds (admin-only risk config)
   * Update risk settings
   */
  async updateRiskSettingsRaw(
    requestParameters: UpdateRiskSettingsRequest
  ): Promise<runtime.ApiResponse<RiskSettings>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling updateRiskSettings."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/risksettings`,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: RiskSettingsPayloadToJSON(requestParameters.riskSettingsPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RiskSettingsFromJSON(jsonValue)
    );
  }

  /**
   * Update the project's risk settings, including the exposure_band thresholds (admin-only risk config)
   * Update risk settings
   */
  async updateRiskSettings(
    requestParameters: UpdateRiskSettingsRequest
  ): Promise<RiskSettings> {
    const response = await this.updateRiskSettingsRaw(requestParameters);
    return await response.value();
  }

  /**
   * Update a custom risk status (admin-only risk config)
   * Update a risk status
   */
  async updateRiskStatusRaw(
    requestParameters: UpdateRiskStatusRequest
  ): Promise<runtime.ApiResponse<RiskStatus>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling updateRiskStatus."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/riskstatuses/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: RiskStatusPayloadToJSON(requestParameters.riskStatusPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RiskStatusFromJSON(jsonValue)
    );
  }

  /**
   * Update a custom risk status (admin-only risk config)
   * Update a risk status
   */
  async updateRiskStatus(
    requestParameters: UpdateRiskStatusRequest
  ): Promise<RiskStatus> {
    const response = await this.updateRiskStatusRaw(requestParameters);
    return await response.value();
  }

  /**
   * Update a custom risk type (admin-only risk config)
   * Update a risk type
   */
  async updateRiskTypeRaw(
    requestParameters: UpdateRiskTypeRequest
  ): Promise<runtime.ApiResponse<RiskType>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling updateRiskType."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/risktypes/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: RiskTypePayloadToJSON(requestParameters.riskTypePayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RiskTypeFromJSON(jsonValue)
    );
  }

  /**
   * Update a custom risk type (admin-only risk config)
   * Update a risk type
   */
  async updateRiskType(
    requestParameters: UpdateRiskTypeRequest
  ): Promise<RiskType> {
    const response = await this.updateRiskTypeRaw(requestParameters);
    return await response.value();
  }
}

/**
 * @export
 * @enum {string}
 */
export enum GetRiskScaleValuesAxisEnum {
  Likelihood = "likelihood",
  Impact = "impact",
}
/**
 * @export
 * @enum {string}
 */
export enum GetRisksExposureBandEnum {
  Low = "low",
  Medium = "medium",
  High = "high",
  Critical = "critical",
}
